import { CommonModule, DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnInit,
} from "@angular/core";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Subject } from "rxjs";
import { AddClientContact } from "../../../../core/models/client/addClientContact";
import { CustomerPaymentMethodDto } from "../../../../core/models/orders/customerPaymentMethodDto";
import { GetBacForSalesOrderDto } from "../../../../core/models/orders/getBacForSalesOrderDto";
import { BuyerComponent } from "../buyer/buyer.component";
import { ClientSearchList } from "../../../../core/models/shared/clientSearchList";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { TableModule } from "primeng/table";
import { AddContactInformationComponent } from "../../../clients/components/add-contact-information/add-contact-information.component";
import { UsersList } from "../../../../core/models/users/users/usersList";
import { HeaderCustomerAccountComponent } from "../header-customer-account/header-customer-account.component";
import { CalendarModule } from "primeng/calendar";
import { OverlayPanel, OverlayPanelModule } from "primeng/overlaypanel";
import { GetBCForSalesOrderDto } from "../../../../core/models/orders/getBCForSalesOrderDto";
import { InputTextModule } from "primeng/inputtext";
import { CheckboxModule } from "primeng/checkbox";
import { RadioButtonModule } from "primeng/radiobutton";
import { computeMinDate } from "../../../../core/utilities/mindate-function";
import { DatePickerModule } from "primeng/datepicker";
@Component({
  selector: "jni-header-quote",
  templateUrl: "./header-quote.component.html",
  styleUrls: ["./header-quote.component.scss"],
  providers: [DatePipe],
  imports: [
    CommonModule,
    SelectModule,
    TableModule,
    DatePickerModule,
    CalendarModule,
    AddContactInformationComponent,
    ReactiveFormsModule,
    FormsModule,
    HeaderCustomerAccountComponent,
    OverlayPanelModule,
    BuyerComponent,
    SelectModule,
    InputTextModule,
    CheckboxModule,
    RadioButtonModule,
  ],
})
export class HeaderQuoteComponent implements OnInit {
  public customerVendor$ = new Subject<string>();
  showSmallLoader = false;
  inHandDate = new Date().toISOString();
  shipDate = new Date().toISOString();
  brandingConsultantObject!: GetBCForSalesOrderDto;
  shipDateCurrentdate = computeMinDate();
  inHandDateCurrentdate = computeMinDate();
  applyCreditCardStatus = true;
  customerAccountNumber = "";
  addClientContact: AddClientContact = {} as AddClientContact;
  displayAddContact = false;
  oneTimeCheckBoxChecked = false;
  templateCheckBoxChecked = false;

  @Input() parent!: FormGroup;
  @Input() bacUserDefaultSelectionId = "";
  @Input() bacList: GetBacForSalesOrderDto[] | UsersList[] = [];
  @Input() brandingConsultantLists: GetBCForSalesOrderDto[] = [];
  @Input() deliveryAddress: {
    id: number;
    name: string;
    status: boolean;
  }[] = [];
  @Input() formErrors!: Record<string, string>;
  @Input() customerPaymentMethodList: CustomerPaymentMethodDto[] = [];
  @Input() customerBillToObject!: ClientSearchList;

  @ViewChild("buyer", { static: false })
  buyer!: BuyerComponent;

  @Output() bcSelectionEvent = new EventEmitter<string>();
  @Output() customerBillToObjectEvent = new EventEmitter();
  @Output() bcSelectionForProspect = new EventEmitter();
  @Output() validationErrorEvent = new EventEmitter();
  @Output() smallLoaderEvent = new EventEmitter();
  @Output() clearShipToEvent = new EventEmitter();
  @Output() contactListRefreshGrid = new EventEmitter();
  @Output() buyerChangeEvent = new EventEmitter<void>();
  @Output() selectedClientCurrencyEvent = new EventEmitter<string>();

  constructor(public datepipe: DatePipe) {}

  ngOnInit(): void {
    this.parent.patchValue({
      orderHeader: {
        type: "Template",
      },
    });
  }

  onShipDateSelection(event: Date) {
    // this.shipDate = event;
    const date = new Date(event);
    this.shipDate = this.datepipe.transform(date, "MM/dd/yyyy") ?? "";

    if (this.shipDate) {
      this.inHandDateCurrentdate = computeMinDate(this.shipDate, false);
    } else {
      this.inHandDateCurrentdate = computeMinDate();
    }
    this.parent.patchValue({
      orderHeader: {
        shipDate: this.shipDate,
      },
    });
  }

  getCustomerBillToData(clientObj: ClientSearchList) {
    this.customerBillToObjectEvent.emit(clientObj);
  }

  logValidationErrors() {
    this.validationErrorEvent.emit();
  }

  getLoaderStatus(status: boolean) {
    this.smallLoaderEvent.emit(status);
  }

  clearShipToForm() {
    this.clearShipToEvent.emit();
  }

  onInHandDateSelection(event: Date) {
    //this.inHandDate = event;
    const date = new Date(event);
    this.inHandDate = this.datepipe.transform(date, "MM/dd/yyyy") ?? "";

    this.parent.patchValue({
      orderHeader: {
        inHandsDate: this.inHandDate,
      },
    });
  }

  onProjectIdSelection(event: GetBCForSalesOrderDto, dropdown: OverlayPanel) {
    this.brandingConsultantObject = event;
    this.bcSelectionEvent.emit(event.personnelNumber);
    this.patchProjectIdInBCField(event);
    dropdown.toggle(false);
  }

  patchProjectIdInBCField(event: GetBCForSalesOrderDto) {
    this.parent.patchValue({
      orderHeader: {
        brandingConsultant: event.projectName,
      },
    });
  }

  // onBrandingConsultantSelection(event: any) {
  //   this.showSmallLoader = true;
  //   event.open();
  // }

  getCreditCard(event: SelectChangeEvent) {
    if (event.value === "CC") {
      this.applyCreditCardStatus = false;
    } else {
      this.applyCreditCardStatus = true;
    }
  }

  onTempleteSelection(value: string) {
    this.parent.patchValue({
      orderHeader: {
        type: value,
      },
    });
  }

  bcSelectionForProspects(event: GetBCForSalesOrderDto) {
    this.bcSelectionForProspect.emit(event);
  }
  getAllBuyers() {
    this.buyer.getAllBuyers();
  }
  addContactInformation() {
    const getBuyerValue: string = this.parent.get([
      "orderHeader",
      "buyer",
    ])?.value;
    if (this.customerBillToObject?.clientAccount && getBuyerValue) {
      const getSplitValues = getBuyerValue.split(" ");
      this.customerAccountNumber = this.customerBillToObject.clientAccount;
      this.addClientContact.firstName = getSplitValues[0] ?? "";
      this.addClientContact.lastName = getSplitValues[1] ?? "";
      this.addClientContact.type = "Buyer";
    } else {
      this.customerAccountNumber = this.customerBillToObject.clientAccount;
      this.addClientContact.firstName = "";
      this.addClientContact.lastName = "";
      this.addClientContact.type = "Buyer";
    }
    this.displayAddContact = true;
  }
  isContactAdded(obj: boolean) {
    if (obj) {
      this.contactListRefreshGrid.emit(true);
      this.buyerChangeEvent.emit();
    }
  }
  populateContactAddedInfo(obj: string) {
    if (obj) {
      this.parent.patchValue({
        orderHeader: {
          buyer: obj,
        },
      });
    }
  }
  getAllBuyersIfClientAccountEvent(clientAccount: string) {
    if (clientAccount) {
      this.buyer.getAllBuyers();
    }
  }

  patchValueInCurrencyFieldEvent(currency: string) {
    this.selectedClientCurrencyEvent.emit(currency);
  }
}
